import(/* webpackMode: "eager" */ "/var/www/vhosts/castly.nl/httpdocs/src/app/global-error.tsx");
